import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../assets/css/style.css';
import {Outline} from '../assets/content/Outline';
import {Link} from 'react-router-dom';
import { useState, useEffect } from 'react';
import { colors } from '@material-ui/core';

export default function TopNavbar() {

  const [showDropdown, setShowDropdown] = useState(false);

  const handleSelect = () => {
    setShowDropdown(false);
  };

  const handleDropdownClick = () => {
    setShowDropdown(!showDropdown);
  };

  const [brandText, setBrandText] = useState('Easy Data Structures');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 600px)');

    const handleResize = (e) => {
      if (e.matches) {
        setBrandText('Easy Data Structures');
      } else {
        setBrandText('Easy Data Structures');
      }
    };

    // Initial check
    handleResize(mediaQuery);

    // Listen for changes
    mediaQuery.addEventListener('change', handleResize);

    // Cleanup
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  // Theme Dark/Light mode 
const [isDark, setIsDark] = useState(() => {
    // Load theme preference from localStorage
    return localStorage.getItem('theme') === 'dark';
  });

  // Apply the theme when `isDark` changes
  useEffect(() => {
    document.body.classList.toggle('dark', isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  // Toggle handler
  const handleToggle = () => {
    setIsDark(prev => !prev);
  };



  return (
    <Navbar collapseOnSelect expand="lg" id="_navbar" variant="dark">
      <div id="navContainer" className='container-fluid'>
        <Navbar.Brand href="/">{brandText}</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Link to="/" className='nav-link'>Home</Link>

            <NavDropdown
              id="nav-dropdown-dark-example"
              title="Topics"
              menuVariant="dark"
              show={showDropdown}
              onSelect={handleSelect}
              onClick={handleDropdownClick}
            >
              <div className="nav-dropdown-scroll">
              { 
                Outline.map(element => {
                    return (
                        <Link key={element.index} className='nav-link' to={`/data-structures/${element.link}`} onClick={() => setShowDropdown(false)}>{element.topic}</Link>
                    )
                })
            }
            </div>
            </NavDropdown>
            <Link to="/data-structures/data-structure" className='nav-link'>Tutorials</Link>
          </Nav>
            <Link to="/blog" className='nav-link blog-link'>Blog</Link>
            <Link to="/feedback" className='nav-link feedback'>Feedback</Link>
            <Link to="/aboutus" className='nav-link aboutUs'>About Us</Link>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button id="theme-toggle" onClick={handleToggle}>
              {isDark ? '☀️' : '🌙'}
            </button>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}
